module.exports = __webpack_public_path__ + "assets/photos/memories/frame-1-mobile--ecb934e3e34a118343f33d5b2c39cc96.jpg";